/* SiwakStick nav active-state JS fallback.
 *
 * Reads window.location.pathname at page load and adds .is-active +
 * aria-current="page" to the matching nav link in .nav-links--left.
 * This duplicates the server-side Liquid logic in hematite-header.liquid,
 * with the critical difference that it runs in the browser AFTER the
 * HTML is delivered , so it works even when Shopify's IndexController
 * or ProductDetailsController page_cache is serving HTML that was
 * rendered before the Liquid active-state logic was added.
 *
 * Loaded on every templated page via hematite-styles.css's parent section
 * files. Tiny, no dependencies, safe to run multiple times (idempotent).
 */
(function () {
  'use strict';

  var path = (window.location.pathname || '/').toLowerCase();

  /* Map current URL to the nav slot that should be active. The order
     matters , more specific matches first (blog before contact, etc.). */
  var slot = null;
  if (path === '/' || path === '/index' || path === '') {
    slot = 'home';
  } else if (path.indexOf('/products/') === 0) {
    slot = 'shop';
  } else if (path.indexOf('/blogs/') === 0 || path.indexOf('/pages/blog') === 0) {
    slot = 'blog';
  } else if (path.indexOf('/pages/contact') === 0) {
    slot = 'contact';
  }
  if (!slot) return;

  /* href patterns that identify each slot. Keep these strict so
     the Cart link in .nav-links--right is never accidentally matched. */
  var slotHrefMatchers = {
    home:    function (href) { return href === '/'; },
    shop:    function (href) { return href.indexOf('/products/') === 0; },
    blog:    function (href) { return href.indexOf('/blogs/') === 0 || href.indexOf('/pages/blog') === 0; },
    contact: function (href) { return href.indexOf('/pages/contact') === 0; }
  };

  function applyActive() {
    /* Both the desktop nav and the mobile drawer get the same treatment
       so the highlighted link reads correctly on either layout. */
    var matcher = slotHrefMatchers[slot];
    if (!matcher) return;
    var selectors = [
      '.nav-links--left a',
      '.mobile-drawer a'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (matcher(href)) {
          a.classList.add('is-active');
          a.setAttribute('aria-current', 'page');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyActive);
  } else {
    applyActive();
  }
})();
